var React = require('react');

function ChevronForward (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Chevron Forward"),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M184 112l144 144-144 144","key":1})]);
}

ChevronForward.defaultProps = {"className":"ionicon","viewBox":"0 0 512 512"};

module.exports = ChevronForward;

ChevronForward.default = ChevronForward;
